import React from 'react';
import { Dialog, DialogContent, Grid } from '@mui/material';
import Balance from './Balance';
import History from './History';
import PaymentReports from './PaymentReport';
import useAuth from '../../../hooks/useAuth';
import useAuthUsers from '../../../hooks/useAuthUsers';
import useWallet from '../../../hooks/useWallet';
import useHostWallet from '../../../hooks/useHostWallet';
import useGetUser from '../../../hooks/useGetUser';

function DialogWallet({ open, onClose }) {
  // const { user } = useAuth();
  const { currentUser } = useAuthUsers();

  const myWallet = useWallet();
  const { hostWallet } = useHostWallet();
  // console.log('----------------------', currentUser);
  const handleClose = () => {
    onClose(false);
  };
  return (
    <Dialog open={open} onClose={handleClose} maxWidth="lg">
      <DialogContent>
        <Grid container spacing={1}>
          <Grid item xs={12} md={6}>
            {currentUser.role === 'cajero' ? (
              <Balance wallet={hostWallet} assignedUser currentUser={currentUser} />
            ) : (
              <Balance wallet={myWallet} currentUser={currentUser} />
            )}
          </Grid>
          <Grid item xs={12} md={6}>
            <History
              user={currentUser}
              neededUserId={currentUser.role === 'cajero' ? currentUser.hostUser : currentUser.id}
            />
          </Grid>
          <Grid item xs={12}>
            <PaymentReports
              user={currentUser}
              neededUserId={currentUser.role === 'cajero' ? currentUser.hostUser : currentUser.id}
            />
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}

export default DialogWallet;
